// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* eslint-disable import/first */

require('./assets/sass/app.scss')

const bugsnag = require('bugsnag-js')
const bugsnagClient = bugsnag('3a6ab9a42b03c10cf5d1de29a90270fe')

import Vue from 'vue'
const bugsnagVue = require('bugsnag-vue')
bugsnagClient.use(bugsnagVue(Vue))
import BootstrapVue from 'bootstrap-vue'
import api from 'axios'
import VueLoading from 'vuex-loading'
import VueShortKey from 'vue-shortkey'
import VueSweetalert2 from 'vue-sweetalert2'
import './registerServiceWorker'

const API_ROOT = process.env.NODE_ENV === 'production'
  ? 'https://backend.expense.guide/api'
  : 'http://backend.expense.guide.local/api'
const PUSHER_KEY = process.env.NODE_ENV === 'production'
  ? '8c9336c874bf8f80961b'
  : '818b38634123a07f96ff'

import Pusher from 'pusher-js'
if (process.env.NODE_ENV === 'development') {
  Pusher.logToConsole = true
}
window.pusher = new Pusher(PUSHER_KEY, {
  cluster: 'eu',
  encrypted: true,
  authEndpoint: API_ROOT + '/broadcasting/auth',
  auth: {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    }
  }
})
window.pusher.connection.bind('connected', function () {
  api.defaults.headers.common['X-Socket-ID'] = window.pusher.connection.socket_id
})

import './filters/DateFormatFilters'
import './filters/NumberFormatFilters'
import './filters/UppercaseFilters'

import AppContainer from './App'
import router from './router'
import store from './store/index'

api.defaults.baseURL = API_ROOT
api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')

const routePath = localStorage.getItem('route_path')

Vue.use(BootstrapVue)
Vue.use(VueLoading)
Vue.use(VueShortKey, { prevent: ['input', 'textarea'] })
Vue.use(VueSweetalert2)
Vue.config.productionTip = false

// Global event bus
Vue.prototype.$eventHub = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  mounted () {
    document.getElementById('initialLoadingBox').style.display = 'none'
  },
  render: h => h(AppContainer),
  vueLoading: new VueLoading({ registerComponents: false })
})

// Validate stored access token if the app has internet connection
if (navigator.onLine) {
  store.dispatch('validateAccessToken').then(result => {
    store.dispatch('getLedgers')
    if (routePath && routePath !== router.currentRoute.path && routePath !== '/' && router.currentRoute.path !== '/terms-of-service' && router.currentRoute.path !== '/privacy-policy' && router.currentRoute.path !== '/cookie-policy' && router.currentRoute.path !== '/subscription') {
      router.push(routePath)
    }
  }).catch(() => {
    if (router.currentRoute.path !== '/registration' && router.currentRoute.path !== '/reset-password-request' && router.currentRoute.name !== 'PasswordReset' && router.currentRoute.path !== '/terms-of-service' && router.currentRoute.path !== '/privacy-policy' && router.currentRoute.path !== '/cookie-policy') {
      router.replace('/login')
    }
    /**
     * Remove the sensitive (GDPR) data from cache
     */
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        if (cacheName.includes('-runtime-')) {
          caches.delete(cacheName)
        }
      })
    })
  })
} else {
  // Fetch this details in offline mode from the service worker
  store.dispatch('getLedgers')
  store.dispatch('getLoggedInUser')
  if (routePath && routePath !== '/') {
    router.push(routePath)
  }
}
